import * as fromRouter from '@ngrx/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RootState } from '@store/index';

export const selectRouter = createFeatureSelector<fromRouter.RouterReducerState<any>>('router');

const {
  selectQueryParams, // select the current route query params
  selectQueryParam, // factory function to select a query param
  selectRouteParams, // select the current route params
  selectRouteParam, // factory function to select a route param
  selectRouteData, // select the current route data
  selectUrl, // select the current url
} = fromRouter.getRouterSelectors(selectRouter);

export namespace RouterSelectors {
  export const selectRouterState = (state: RootState) => state.router.state.root;

  export const selectRouterUrl = selectUrl;
  export const selectRouterQueryParams = selectQueryParams;
  export const selectRouterParams = selectRouteParams;
  export const selectFragment = createSelector(selectRouterState, state => state.fragment);
}
